import { api } from './api'
import { globalMessaging } from './globalMessaging'
import { logs } from './logs'
import { notification } from './notification'
import { shipments } from './shipments'

export const globalMiddleware = [api, shipments, notification, globalMessaging, logs]
